"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOrientationSearchResultsCountDto = instanceOfOrientationSearchResultsCountDto;
exports.OrientationSearchResultsCountDtoFromJSON = OrientationSearchResultsCountDtoFromJSON;
exports.OrientationSearchResultsCountDtoFromJSONTyped = OrientationSearchResultsCountDtoFromJSONTyped;
exports.OrientationSearchResultsCountDtoToJSON = OrientationSearchResultsCountDtoToJSON;
exports.OrientationSearchResultsCountDtoToJSONTyped = OrientationSearchResultsCountDtoToJSONTyped;
/**
 * Check if a given object implements the OrientationSearchResultsCountDto interface.
 */
function instanceOfOrientationSearchResultsCountDto(value) {
    if (!('count' in value) || value['count'] === undefined)
        return false;
    return true;
}
function OrientationSearchResultsCountDtoFromJSON(json) {
    return OrientationSearchResultsCountDtoFromJSONTyped(json, false);
}
function OrientationSearchResultsCountDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'count': json['count'],
    };
}
function OrientationSearchResultsCountDtoToJSON(json) {
    return OrientationSearchResultsCountDtoToJSONTyped(json, false);
}
function OrientationSearchResultsCountDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'count': value['count'],
    };
}
//# sourceMappingURL=OrientationSearchResultsCountDto.js.map